import axios from 'axios';
import { Dispatch } from 'react';
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect';
import jwtDecode from 'jwt-decode';

import { request } from '../../utils/request';
import { LOGIN } from '../../queries/login';
import { UserService } from '../User/UserService';
import { useUserAccess } from '../../hooks/context/useUserAccess.hook';

export class AuthService {
  static async getUserData(email: string): Promise<any> {
    try {
      const { data } = await axios.get('https://api.ipinfodb.com/v3/ip-city/?key=488691776a8356bed022e22910fbd7e43f6b26f0d2ef3181fd0c9b1b49514bf9&format=json');

      return {
        as: '-',
        isp: '-',
        org: '-',
        region: '-',
        browser: browserName,
        city: data.city,
        country: data.country,
        countryCode: data.countryCode,
        ip: data.ipAddress,
        lat: data.latitude,
        lon: data.longitude,
        os: osName,
        platform: osVersion,
        regionName: data.regionName,
        system: 'content-panel',
        timezone: data.timezone,
        type: 'login',
        user: email,
        version: browserVersion,
        zip: data.zipCode,
      };
    } catch (error) {
      console.error('Failed to get user data:', error);
    }

    return undefined;
  }

  static async login(email: string, password: string, userData: string): Promise<string> {
    const response = await request(LOGIN, { email, password, userData });
    const { authenticator } = response.data;

    if (authenticator) {
      return authenticator.access_token;
    }

    throw new Error('Error when authenticating');
  }

  static persistData(token: string, dispatchUserData: Dispatch<IJwtDecoded>): IUser {
    this.persistToken(token);
    const userData = jwtDecode<IJwtDecoded>(token);
    dispatchUserData(userData);
    return userData;
  }

  static persistToken(token: string): void {
    localStorage.setItem('accessToken', token);
  }

  static cleanLocalStorageAuthData(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userAccess');
    localStorage.removeItem('user');
  }

  static logout(reloadPage = false): void {
    this.cleanLocalStorageAuthData();
    if (reloadPage) window.location.reload();
  }

  static getToken(): string | null {
    return localStorage.getItem('accessToken');
  }

  static isLogged(): boolean {
    try {
      const token = this.getToken();
      if (token) {
        const decoded = jwtDecode<IJwtDecoded>(token);
        const now = new Date().getTime();

        if (now > decoded.exp * 1000) {
          return false;
        }

        return true;
      }
      return false;
    } catch (e) {
      return false;
    }
  }

  static useDependenciesFetch(): (userId: string) => Promise<void> {
    const [, setUserAccess] = useUserAccess();

    return async (userId: string) => {
      const userService = new UserService(userId);
      const userAccess = await userService.getUserAccess();
      setUserAccess(userAccess);
    };
  }
}
